import React from 'react'
import actions from 'redux/actions'
import { constants, snowplow, ce2 } from 'common/helpers'

import Button from 'components/_new/Button/Button'

import messages from './messages'


const handleClick = (event, onClick) => {
  if (typeof onClick === 'function') {
    onClick(event)
  }

  ce2.set(2, constants.analyticsEvents.changeFrequencyClick)
  snowplow.track(constants.snowplowEvents.changeFrequencyClick)
  actions.models.modals.open(constants.modals.ChangeFrequency, {
    popup: 'change frequency button',
  })
}

const ChangeFrequencyButton = ({ className, fullWidth, onClick  }) => (
  <Button
    className={className}
    title={messages.title}
    dataTestId={constants.testIds.profile.orderStatusButtons.changeFrequency}
    fullWidth={fullWidth}
    weight="normal"
    color="brand"
    size="md"
    uppercase
    onClick={(event) => handleClick(event, onClick)}
  />
)


export default ChangeFrequencyButton
